function ProfileCompletedIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      fill="#AEAAB5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#fff" d="M0 0h50v50H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14.364a2.746 2.746 0 012.746-2.746h33.817a2.746 2.746 0 012.746 2.746v9.541a10.274 10.274 0 00-2.564-.323c-5.664 0-10.255 4.59-10.255 10.254 0 .886.112 1.745.323 2.564H6.746A2.746 2.746 0 014 33.654v-19.29zM24.51 17.6h13.672v2.563H24.51V17.6zm-6.9 3.112a3.112 3.112 0 11-6.224 0 3.112 3.112 0 016.224 0zm-9.338 7.78s1.479-3.112 6.225-3.112c4.746 0 6.224 3.113 6.224 3.113v1.556H8.272v-1.556zm23.929-5.765H24.51v2.564h7.69v-2.564zm-7.691 5.128h5.127v2.563H24.51v-2.563z"
      />
      <path d="M40.746 25.29a8.549 8.549 0 00-8.546 8.546 8.549 8.549 0 008.546 8.546 8.549 8.549 0 008.545-8.546 8.549 8.549 0 00-8.545-8.545zm-1.71 12.819l-4.272-4.273 1.205-1.205 3.068 3.06 6.486-6.486 1.204 1.213-7.69 7.691z" />
    </svg>
  )
}

export default ProfileCompletedIcon
